<template>
  <div>
    <ul>
      <li
        v-for="itemAttachment in files"
        :key="itemAttachment.ItemAttachmentID"
      >
        <a :href="`${rooturl}${itemAttachment.AttachmentUri}`">
          <font-awesome-icon
            v-if="itemAttachment.ContentType == '.pdf'"
            :icon="['fas', 'file-pdf']"
          />
          {{ itemAttachment.FileName }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    rooturl: {
      required: true,
      type: String,
      default: () => {
        return ''
      }
    },
    item: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
    itemAttachments: {
      required: false,
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    files: function() {
      if (this.itemAttachments.length > 0) return this.itemAttachments
      return this.item.ItemAttachments
    }
  }
}
</script>

<style></style>
